import styles from './index.module.css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import DOMPurify from 'dompurify';
import { useEffect, useRef } from 'react';
gsap.registerPlugin(ScrollTrigger);
const MainPoint = ({ textData ,language}) => {
  const text1Ref = useRef(null);
  const text2Ref = useRef(null);
  const text3Ref = useRef(null);
  const text4Ref = useRef(null);
  const ctnRef = useRef(null);
  const videoRef = useRef(null);
  const textBoxRef = useRef(null);
  const icon1Ref = useRef(null);
  const icon2Ref = useRef(null);
  const icon3Ref = useRef(null);
  const icon4Ref = useRef(null);
  const icon5Ref = useRef(null);
  const icon6Ref = useRef(null);
  const iconHeaderRef = useRef(null);

  useEffect(() => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ctnRef.current,
        start: 'top top',
        end: '180%',
        pin: true,
        scrub: 1,
      },
    });

    tl.to(
      text1Ref.current,
      {
        y: -100,
        duration: 3,
      },
      0,
    );

    tl.to(
      text1Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      0,
    );

    tl.to(
      text1Ref.current,
      {
        opacity: 0,
        duration: 1,
      },
      2,
    );

    tl.to(
      text2Ref.current,
      {
        y: -100,
        duration: 3,
      },
      3,
    );

    tl.to(
      text2Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      3,
    );

    tl.to(
      text2Ref.current,
      {
        opacity: 0,
        duration: 1,
      },
      5,
    );

    tl.to(
      text3Ref.current,
      {
        y: -100,
        duration: 3,
      },
      6,
    );

    tl.to(
      text3Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      6,
    );

    tl.to(
      text3Ref.current,
      {
        opacity: 0,
        duration: 1,
      },
      8,
    );

    tl.to(
      iconHeaderRef.current,
      {
        y: 0,
        duration: 3,
      },
      9,
    );

    tl.to(
      iconHeaderRef.current,
      {
        opacity: 1,
        duration: 1,
      },
      9,
    );

    tl.to(
      icon1Ref.current,
      {
        y: 0,
        duration: 3,
      },
      9.4,
    );

    tl.to(
      icon1Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      9.4,
    );

    tl.to(
      icon2Ref.current,
      {
        y: 0,
        duration: 3,
      },
      9.8,
    );

    tl.to(
      icon2Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      9.8,
    );

    tl.to(
      icon3Ref.current,
      {
        y: 0,
        duration: 3,
      },
      10.2,
    );

    tl.to(
      icon3Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      10.2,
    );

    tl.to(
      icon4Ref.current,
      {
        y: 0,
        duration: 3,
      },
      10.6,
    );

    tl.to(
      icon4Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      10.6,
    );

    tl.to(
      icon5Ref.current,
      {
        y: 0,
        duration: 3,
      },
      11,
    );

    tl.to(
      icon5Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      11,
    );

    tl.to(
      icon6Ref.current,
      {
        y: 0,
        duration: 3,
      },
      11.4,
    );

    tl.to(
      icon6Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      11.4,
    );
  }, []);

  return (
    <div className={styles.ctn} ref={ctnRef}>
      <video
        autoPlay
        loop
        playsInline
        muted
        preload="true"
        src={`http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiverayf100/f100-video-summary${language === 'cn' ? '' : '-en'}.mp4`}
        poster={`http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/fiverayf100/f100-video-summary-cover${language === 'cn' ? '' : '-en'}.jpg`}
        ref={videoRef}
      ></video>
      <div className={styles.textBox} ref={textBoxRef}>
        <h2
          ref={text1Ref}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text4']),
          }}
        ></h2>
        <h2
          ref={text2Ref}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text5']),
          }}
        ></h2>
        <h2
          ref={text3Ref}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text6']),
          }}
        ></h2>
        <div ref={text4Ref} className={styles.text4}>
          <h2
            ref={iconHeaderRef}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text7']),
            }}
          ></h2>
          <div className={styles.iconBox}>
            <div className={styles.iconItem} ref={icon1Ref}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.62025 21.9999C6.833 21.9999 6.17523 21.8703 5.64694 21.611C5.11865 21.3517 4.71984 20.9531 4.45052 20.4153C4.18119 19.8679 4.03099 19.162 3.99992 18.2976L6.37722 17.9663C6.38758 18.4657 6.43419 18.8691 6.51706 19.1764C6.61029 19.4837 6.73459 19.7046 6.88997 19.8391C7.05571 19.9735 7.25252 20.0407 7.48041 20.0407C7.77045 20.0407 7.95691 19.9495 8.03977 19.767C8.133 19.5846 8.17962 19.3925 8.17962 19.1908C8.17962 18.7106 8.05531 18.3072 7.80671 17.9807C7.5581 17.6446 7.22145 17.3084 6.79674 16.9723L5.70909 16.0936C5.23259 15.719 4.82861 15.2964 4.49713 14.8258C4.17601 14.3457 4.01546 13.755 4.01546 13.0539C4.01546 12.0647 4.33139 11.3108 4.96327 10.7922C5.59514 10.264 6.45491 9.99992 7.54256 9.99992C8.21587 9.99992 8.75452 10.1056 9.1585 10.3168C9.57285 10.5281 9.88361 10.8066 10.0908 11.1524C10.3083 11.4885 10.4533 11.8487 10.5258 12.2328C10.6087 12.6074 10.6553 12.9675 10.6657 13.3132L8.27284 13.587C8.26248 13.2412 8.23659 12.9435 8.19515 12.6938C8.16408 12.4345 8.09157 12.2376 7.97762 12.1032C7.86368 11.9591 7.68758 11.8871 7.44933 11.8871C7.19037 11.8871 6.99873 11.9879 6.87443 12.1896C6.76049 12.3913 6.70351 12.593 6.70351 12.7946C6.70351 13.2268 6.81228 13.5822 7.02981 13.8607C7.2577 14.1296 7.55292 14.4129 7.91547 14.7106L8.95651 15.5605C9.50552 15.9927 9.96648 16.4825 10.3394 17.0299C10.7227 17.5773 10.9143 18.2544 10.9143 19.0611C10.9143 19.6086 10.7796 20.108 10.5103 20.5593C10.241 21.0011 9.85771 21.3517 9.3605 21.611C8.87364 21.8703 8.29356 21.9999 7.62025 21.9999Z"
                  fill="white"
                />
                <path
                  d="M15.8658 21.9999C14.9231 21.9999 14.1773 21.8463 13.6283 21.5389C13.0793 21.2316 12.6857 20.7898 12.4474 20.2136C12.2092 19.6374 12.0901 18.9507 12.0901 18.1536V13.8174C12.0901 13.0107 12.2092 12.324 12.4474 11.7574C12.6857 11.1908 13.0793 10.7586 13.6283 10.4609C14.1773 10.1536 14.9231 9.99992 15.8658 9.99992C16.8188 9.99992 17.5698 10.1536 18.1188 10.4609C18.6781 10.7586 19.077 11.1908 19.3152 11.7574C19.5534 12.324 19.6726 13.0107 19.6726 13.8174V18.1536C19.6726 18.9507 19.5534 19.6374 19.3152 20.2136C19.077 20.7898 18.6781 21.2316 18.1188 21.5389C17.5698 21.8463 16.8188 21.9999 15.8658 21.9999ZM15.8658 20.1704C16.1558 20.1704 16.3682 20.1032 16.5028 19.9687C16.6375 19.8343 16.7255 19.6614 16.767 19.4501C16.8084 19.2388 16.8291 19.0227 16.8291 18.8018V13.1836C16.8291 12.9531 16.8084 12.737 16.767 12.5353C16.7255 12.324 16.6375 12.1512 16.5028 12.0167C16.3682 11.8823 16.1558 11.815 15.8658 11.815C15.5965 11.815 15.3945 11.8823 15.2598 12.0167C15.1251 12.1512 15.0371 12.324 14.9957 12.5353C14.9542 12.737 14.9335 12.9531 14.9335 13.1836V18.8018C14.9335 19.0227 14.949 19.2388 14.9801 19.4501C15.0216 19.6614 15.1044 19.8343 15.2287 19.9687C15.3634 20.1032 15.5757 20.1704 15.8658 20.1704Z"
                  fill="white"
                />
                <path
                  d="M24.7059 21.9999C23.9186 21.9999 23.2609 21.8703 22.7326 21.611C22.2043 21.3517 21.8055 20.9531 21.5361 20.4153C21.2668 19.8679 21.1166 19.162 21.0855 18.2976L23.4628 17.9663C23.4732 18.4657 23.5198 18.8691 23.6027 19.1764C23.6959 19.4837 23.8202 19.7046 23.9756 19.8391C24.1413 19.9735 24.3382 20.0407 24.566 20.0407C24.8561 20.0407 25.0425 19.9495 25.1254 19.767C25.2186 19.5846 25.2652 19.3925 25.2652 19.1908C25.2652 18.7106 25.1409 18.3072 24.8923 17.9807C24.6437 17.6446 24.3071 17.3084 23.8824 16.9723L22.7947 16.0936C22.3182 15.719 21.9142 15.2964 21.5828 14.8258C21.2616 14.3457 21.1011 13.755 21.1011 13.0539C21.1011 12.0647 21.417 11.3108 22.0489 10.7922C22.6808 10.264 23.5405 9.99992 24.6282 9.99992C25.3015 9.99992 25.8401 10.1056 26.2441 10.3168C26.6585 10.5281 26.9692 10.8066 27.1764 11.1524C27.3939 11.4885 27.539 11.8487 27.6115 12.2328C27.6943 12.6074 27.741 12.9675 27.7513 13.3132L25.3585 13.587C25.3481 13.2412 25.3222 12.9435 25.2808 12.6938C25.2497 12.4345 25.1772 12.2376 25.0633 12.1032C24.9493 11.9591 24.7732 11.8871 24.535 11.8871C24.276 11.8871 24.0844 11.9879 23.9601 12.1896C23.8461 12.3913 23.7891 12.593 23.7891 12.7946C23.7891 13.2268 23.8979 13.5822 24.1154 13.8607C24.3433 14.1296 24.6385 14.4129 25.0011 14.7106L26.0421 15.5605C26.5911 15.9927 27.0521 16.4825 27.425 17.0299C27.8083 17.5773 27.9999 18.2544 27.9999 19.0611C27.9999 19.6086 27.8653 20.108 27.5959 20.5593C27.3266 21.0011 26.9433 21.3517 26.4461 21.611C25.9593 21.8703 25.3792 21.9999 24.7059 21.9999Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.333252 8.66659C0.333252 7.37792 1.37792 6.33325 2.66659 6.33325H29.3333C30.6219 6.33325 31.6666 7.37792 31.6666 8.66659V23.3333C31.6666 24.6219 30.6219 25.6666 29.3333 25.6666H2.66659C1.37792 25.6666 0.333252 24.6219 0.333252 23.3333V8.66659ZM2.66659 8.33325C2.48249 8.33325 2.33325 8.48249 2.33325 8.66659V23.3333C2.33325 23.5173 2.48249 23.6666 2.66659 23.6666H29.3333C29.5173 23.6666 29.6666 23.5173 29.6666 23.3333V8.66659C29.6666 8.48249 29.5173 8.33325 29.3333 8.33325H2.66659Z"
                  fill="white"
                />
              </svg>

              <h5
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData['text8']),
                }}
              ></h5>
            </div>
            <div className={styles.iconItem} ref={icon2Ref}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.00011 23.9999V10.9999H25.0001V23.9999H7.00011Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M28.0108 6.66657H20.5521L23.9334 3.28524L22.0481 1.3999L16.7814 6.66657H15.2188L9.95211 1.3999L8.06677 3.28524L11.4481 6.66657H3.98944C3.27344 6.66657 2.66677 7.2639 2.66677 7.9999V26.6666C2.66572 26.8411 2.69913 27.014 2.7651 27.1756C2.83106 27.3371 2.92828 27.4841 3.05117 27.608C3.17406 27.7318 3.32021 27.8302 3.48122 27.8975C3.64223 27.9648 3.81494 27.9996 3.98944 27.9999H28.0108C28.7268 27.9999 29.3334 27.4026 29.3334 26.6666V7.9999C29.3334 7.2599 28.7414 6.66657 28.0108 6.66657ZM5.00011 9.99988C5.00011 9.44759 5.44782 8.99988 6.00011 8.99988H26.0001C26.5524 8.99988 27.0001 9.44759 27.0001 9.99988V24.9999C27.0001 25.5522 26.5524 25.9999 26.0001 25.9999H6.00011C5.44782 25.9999 5.00011 25.5522 5.00011 24.9999V9.99988Z"
                  fill="white"
                />
              </svg>

              <h5
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData['text9']),
                }}
              ></h5>
            </div>
            <div className={styles.iconItem} ref={icon3Ref}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6666 23.332H10.5879C10.1919 21.6347 8.40528 20.2467 7.67195 19.332C6.4162 17.7631 5.62921 15.8713 5.40163 13.8746C5.17405 11.878 5.51515 9.85761 6.38562 8.04632C7.25609 6.23504 8.62053 4.70649 10.3218 3.63678C12.023 2.56706 13.9918 1.99968 16.0014 2C18.011 2.00032 19.9796 2.56833 21.6805 3.63859C23.3814 4.70886 24.7453 6.23784 25.6152 8.0494C26.4851 9.86097 26.8256 11.8814 26.5973 13.878C26.3691 15.8746 25.5815 17.7661 24.3253 19.3347C23.5919 20.248 21.8079 21.636 21.4119 23.332H17.3333V16.6653H14.6666V23.332ZM21.3333 25.9987V27.332C21.3333 28.0392 21.0523 28.7175 20.5522 29.2176C20.0521 29.7177 19.3739 29.9987 18.6666 29.9987H13.3333C12.626 29.9987 11.9478 29.7177 11.4477 29.2176C10.9476 28.7175 10.6666 28.0392 10.6666 27.332V25.9987H21.3333Z"
                  fill="white"
                />
              </svg>

              <h5
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData['text10']),
                }}
              ></h5>
            </div>
            <div className={styles.iconItem} ref={icon4Ref}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.9999 10.0001C15.3319 10 14.6794 9.80398 14.1268 9.43735C13.5743 9.07073 13.1473 8.55044 12.9012 7.94394C12.6551 7.33744 12.6012 6.67272 12.7465 6.03594C12.8918 5.39917 13.2297 4.81973 13.7162 4.37273C14.3127 3.82445 15.7776 2.83729 15.5554 0.666748C18.2222 2.40318 19.5556 4.13962 16.8888 6.74427C17.3332 6.74427 17.9999 6.74427 19.1111 5.67202C19.2311 6.00759 19.3333 6.36833 19.3333 6.74427C19.3333 7.60776 18.9821 8.43589 18.357 9.04648C17.7318 9.65706 16.884 10.0001 15.9999 10.0001Z"
                  fill="white"
                />
                <path
                  d="M8 13.3334C8 12.597 8.59695 12.0001 9.33333 12.0001H22.6667C23.403 12.0001 24 12.597 24 13.3334V29.3334C24 30.0698 23.403 30.6667 22.6667 30.6667H9.33333C8.59695 30.6667 8 30.0698 8 29.3334V13.3334Z"
                  fill="white"
                />
                <path
                  d="M15.3333 10.6667H16.6667V12.0001H15.3333V10.6667Z"
                  fill="white"
                />
              </svg>

              <h5
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData['text11']),
                }}
              ></h5>
            </div>
            <div className={styles.iconItem} ref={icon5Ref}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.3333 13.3333H26.6666L14.6666 30.6666V18.6666H5.33325L17.3333 1.33325V13.3333Z"
                  fill="white"
                />
              </svg>

              <h5
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData['text12']),
                }}
              ></h5>
            </div>
            <div className={styles.iconItem} ref={icon6Ref}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.9999 30.6667C13.9961 30.6665 12.0386 30.0643 10.3811 28.9383C8.72363 27.8122 7.44268 26.2142 6.70434 24.3514C5.966 22.4886 5.80432 20.4469 6.24026 18.4911C6.6762 16.5353 7.68965 14.7556 9.14921 13.3827C10.9385 11.6987 15.3332 8.66667 14.6665 2C22.6665 7.33333 26.6665 12.6667 18.6665 20.6667C19.9999 20.6667 21.9999 20.6667 25.3332 17.3733C25.6932 18.404 25.9999 19.512 25.9999 20.6667C25.9999 23.3188 24.9463 25.8624 23.0709 27.7377C21.1956 29.6131 18.652 30.6667 15.9999 30.6667Z"
                  fill="white"
                />
              </svg>

              <h5
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData['text13']),
                }}
              ></h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainPoint;
